export default "media"